/* eslint-disable import/prefer-default-export */
import actTeam from './actTeam';
import actTeamMember from './actTeamMember';
import ai from './ai';
import aiAssist from './aiAssist';
import app from './app';
import client from './client';
import clientAllocation from './clientAllocation';
import clientDetails from './clientDetails';
import clinic from './clinic';
import coordinate from './coordinate';
import crisis from './crisis';
import deleteRequests from './deleteRequests';
import dictionaries from './dictionaries';
import localAdmin from './localAdmin';
import locationGroups from './locationGroups';
import medicationLogistics from './medicationLogistics';
import network from './network';
import organization from './organization';
import programAssistant from './programAssistant';
import release from './release';
import reports from './reports';
import resource from './resource';
import shelters from './shelters';
import snackbar from './snackbar';
import sosRequests from './sosRequests';
import superAdmin from './superAdmin';
import systemAlert from './systemAlert';
import user from './user';
import utilization from './utilization';
import visits from './visits';

import type { IStoreModel } from './types';

/** Same object passed to `createStore` in `~/store` — exported for test store factory. */
export const rootModel: IStoreModel = {
  app,
  user,
  clinic,
  snackbar,
  actTeam,
  actTeamMember,
  localAdmin,
  dictionaries,
  client,
  clientDetails,
  clientAllocation,
  superAdmin,
  medicationLogistics,
  coordinate,
  programAssistant,
  visits,
  deleteRequests,
  reports,
  sosRequests,
  shelters,
  organization,
  resource,
  release,
  systemAlert,
  locationGroups,
  ai,
  network,
  utilization,
  crisis,
  aiAssist,
};
